import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { ApplicationPreloadService } from 'projects/admin/src/app/service/application-preload.service';
import { IAuthStore } from 'shared/auth/store/auth.reducer';
import { KeycloakAuthBaseService } from 'shared/services/keycloak-auth-base.service';
import { LoggerService } from 'shared/services/logger.service';

@Injectable({
	providedIn: 'root',
})
export class AdminKeycloakAuthService extends KeycloakAuthBaseService {
	constructor(
		logger: LoggerService,
		dialog: MatDialog,
		router: Router,
		store: Store<{ auth: IAuthStore }>,
		private applicationPreloadService: ApplicationPreloadService
	) {
		super(logger, dialog, router, store);
	}

	public async preload(): Promise<void> {
		return this.applicationPreloadService.preload();
	}
}
